import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { localeAwareFormat } from 'app/lib/date';
import { type Profile } from 'app/network/profile';
import { useTranslation } from 'react-i18next';
import { PartagePlusBadge } from 'app/components/partage-plus-badge';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { IconCalendar } from '@tabler/icons-react-native';
import type { ProfileNamespace } from './shared';

export function MemberSince({
  ns,
  profile,
  subscribed,
}: {
  ns: ProfileNamespace;
  profile?: Profile;
  subscribed?: boolean | null;
}) {
  const { t } = useTranslation();
  return (
    <Row alignItems="center" gap="spacing.general.x2">
      <IconCalendar strokeWidth={ICON_STROKE_WIDTH} size={18} color="#999999" />
      <Row alignItems="center" gap="spacing.general.x1" flex={1} flexWrap="wrap">
        {subscribed ? (
          <Row gap="spacing.general.x1" alignItems="center">
            <Text color="text.primary" variant="bodyBase">
              {t('subscribedMemberSince.1', { ns })}
            </Text>
            <PartagePlusBadge variant="small" />
            <Text color="text.primary" variant="bodyBase">
              {t('subscribedMemberSince.3', { ns })}
            </Text>
          </Row>
        ) : (
          <Text color="text.primary" variant="bodyBase">
            {t('memberSince', { date: '', ns })}
          </Text>
        )}
        <Text color="text.primary" fontWeight="600" variant="bodyBase">
          {profile?.createdAt
            ? localeAwareFormat(new Date(profile.createdAt), t('dateFormat_MMMYYYY', { ns: 'common' }))
            : '-'}
        </Text>
      </Row>
    </Row>
  );
}
